import styled from 'styled-components'

export const ConversationOrderSummaryFullRowStyled = styled.div<{
  $isDivider?: boolean
}>`
  grid-column: 1 / -1;
  margin: ${(props) =>
    props.$isDivider
      ? `${props.theme.space.small} 0`
      : `0 0 ${props.theme.space.small}`};
`
